import { HAS_WINDOW } from '@eb/feature-detection';

export const SET_HOVER_EVENT_TARGET = 'search/eventCard/hover';
export const setHoverEventTarget = (eid) => ({
    type: SET_HOVER_EVENT_TARGET,
    payload: eid,
});

export const GOOGLE_MAPS_SCRIPT_LOADED = 'search/map/load';
export const setGoogleMapsLoaded = () => ({
    type: GOOGLE_MAPS_SCRIPT_LOADED,
});

export const SET_FILTER_TYPE_TO_SHOW = 'search/filters/setFilterTypeToShow';
export const setFilterTypeToShow = (val) => ({
    type: SET_FILTER_TYPE_TO_SHOW,
    payload: val,
});

export const OPEN_CLOSE_ANIMATED_DRAWER =
    'search/filters/openCloseAnimatedDrawer';
export const openCloseAnimatedDrawer = (
    open,
    filterType,
    shouldScroll = true,
) => (dispatch) => {
    dispatch({
        type: OPEN_CLOSE_ANIMATED_DRAWER,
        payload: { open, filterType },
    });

    if (shouldScroll && HAS_WINDOW) {
        window.scrollTo(0, 0);
    }
};
